import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Server-side rendering check
  const isServer = typeof window === 'undefined';

  // Start with desktop by default (false) to avoid flash
  const [isMobile, setIsMobile] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (isServer) return;

    // Set initial value immediately based on window width
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);

    // Set up listener for window resize
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    // Use the correct event listener based on browser support
    if (mql.addEventListener) {
      mql.addEventListener("change", onChange);
      return () => mql.removeEventListener("change", onChange);
    } else {
      // Fallback for older browsers
      window.addEventListener('resize', onChange);
      return () => window.removeEventListener('resize', onChange);
    }
  }, [isServer]);

  return isMobile;
}
